import React, { useState } from "react";
import PropTypes from "prop-types";
import Input from "./Input";
import ValidationMessage from "../detail/ValidationMessage";
import "./PasswordInput.scss";

/**
 * Numeric text box component
 * @module
 * @param {string} name - Name
 * @param {func} onChange - Function invoked on value change
 * @param {func} [onBlur] - Function invoked on input blur
 * @param {number} [value] - Current value
 * @param {bool} [required] - Is input required?
 * @param {string} [validationMessage] - Validation message if field is invalid
 * @param {bool} [disabled] - Is input readonly?
 * @param {number} [tabIndex] - Tabindex
 * @param {string} [placeholder] - Placeholder
 * @param {string} [mask] - Mask
 * @param {string} [defaultValue] - Default value
 * @param {string} [title] - Title - shows on focus above cursor
 * @param {string} [autoComplete] - HTML attribute: autocomplete
 */
const PasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [clickActive, setClickActive] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const onBlur = () => {
    if (props.onBlur) {
      props.onBlur(props.name, props.value);
    }
  };

  const {
    name,
    value,
    required,
    validationMessage,
    disabled,
    tabIndex,
    pattern,
    onChange,
    title,
    label,
    isInvalid,
    autoComplete
  } = props;

  const className = isInvalid ? "validation-invalid" : "";

  return (
    <div className="password">
      <div className="label">{label}</div>
      <div className={`field ${className}`}>
        <Input
          type={!showPassword ? "password" : "text"}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          required={required}
          validationMessage={validationMessage || "Povinné"}
          pattern={pattern}
          disabled={disabled}
          tabIndex={tabIndex}
          title={title}
          autoComplete={autoComplete || "on"}
        />
        {value && (
          <div className="showPassword">
            <div
              onClick={() => setClickActive(!clickActive)}
              onMouseDown={(e) => e.preventDefault()}
              onMouseUp={clickActive ? () => setShowPassword(true) : undefined}
              onMouseLeave={
                !clickActive ? () => handleTogglePassword(false) : undefined
              }
              onMouseEnter={
                !clickActive ? () => setShowPassword(true) : undefined
              }
              id="maskValue"
              className={showPassword ? "showPassword-eye" : "hidePassword-eye"}>
              <span>&#128065;</span>
            </div>
          </div>
        )}
      </div>
      <ValidationMessage
        required={required}
        validationMessage={validationMessage}
      />
    </div>
  );
};

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  isInvalid: PropTypes.bool,
  value: PropTypes.string,
  required: PropTypes.bool,
  validationMessage: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  title: PropTypes.string,
  autoComplete: PropTypes.string
};

export default PasswordInput;
